export default "__VITE_ASSET__BYXGnmgX__"